import { createSlice } from '@reduxjs/toolkit';

const toArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === "string" && value.trim()) {
        return [value.trim()];
    }
    return [];
};

/**
 * Приводит пользователя из login/refresh/me к одному виду: roles всегда массив,
 * permissions всегда массив. Старый бэкенд отдавал только `role`.
 */
export const normalizeUser = (user) => {
    if (!user) {
        return null;
    }
    const roles = toArray(user.roles).length > 0 ? toArray(user.roles) : toArray(user.role);
    const permissions = toArray(user.permissions);
    return {...user, roles, permissions};
};

const initialState = {
    user: null,
    error: null,
    token: null,
    refreshToken: null
}

export const authSlice = createSlice({
    name: "@@user",
    initialState,
    reducers:{
        logout: (state, _) => {

            state.user = null;
            state.error = null;
            state.token = null;
            state.refreshToken = null;

        },
        setCredentials: (state, action) => {
            const {user, jwt, refreshToken} = action.payload;
            state.user = normalizeUser(user);
            state.token = jwt;
            state.refreshToken = refreshToken;
        },
        updateUser: (state, action) => {
            state.user = normalizeUser(action.payload);
        }
    },

})

export const authReducer = authSlice.reducer;

export const { logout, setCredentials, updateUser } = authSlice.actions;

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentToken = (state) => state.auth.token
